import { render, staticRenderFns } from "./Tester.vue?vue&type=template&id=ada4998c&scoped=true"
import script from "./Tester.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tester.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Tester.vue?vue&type=style&index=0&id=ada4998c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada4998c",
  null
  
)

export default component.exports